module.exports = __webpack_public_path__ + "static/media/sign-up-bg.e9764571.png";